<template>
  <a-drawer title="口令列表" @close="visible=false" :visible="visible" :width="800">
    <AddFreeInput ref="add" :ids="currentRobotId" @ok="$refs.table.refresh()"/>
    <div class="table-page-search-wrapper">
      <!--      <a-form layout="inline">-->
      <!--        <a-row :gutter="48">-->
      <!--          <a-col :md="6" :sm="24">-->
      <!--            <a-form-item label="搜索条件">-->
      <!--              <a-select v-model="queryParam.search_condition" placeholder="请选择" allowClear>-->
      <!--                <a-select-option value="1">抽奖名称</a-select-option>-->
      <!--              </a-select>-->
      <!--            </a-form-item>-->
      <!--          </a-col>-->
      <!--          <a-col :md="6" :sm="24">-->
      <!--            <a-form-item label="搜索关键字">-->
      <!--              <a-input v-model="queryParam.keywords" placeholder="请输入" />-->
      <!--            </a-form-item>-->
      <!--          </a-col>-->
      <!--          <a-col :md="6" :sm="24">-->
      <!--            <span-->
      <!--              class="table-page-search-submitButtons"-->
      <!--            >-->
      <!--              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>-->
      <!--              <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>-->

      <!--            </span>-->
      <!--          </a-col>-->
      <!--        </a-row>-->
      <!--      </a-form>-->
    </div>

    <s-table
      ref="table"
      :pagination="{position: 'bottom'}"
      :columns="columns"
      rowKey="id"
      :data="loadData" >
      <span slot="status" slot-scope="text">
        <span>
          <a-tag v-if="text == '0'" color="green">未使用</a-tag>
          <a-tag v-else-if="text == '1'" color="orange">已使用</a-tag>
        </span>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleDel(record)">删除</a>

      </span>
    </s-table>

    <EditLuckyModal ref="edit" @ok="$refs.table.refresh()" />
  </a-drawer>
</template>

<script>
import PageView from '@/layouts/PageView'
import { STable } from '@/components'
import SearchRobot from '@/views/components/SearchRobot/SearchRobot'
import { LuckyAPI } from '@/api/lucky'
import AddFreeInput from '@/views/lucky/components/AddFreeInput'
import EditLuckyModal from '@/views/lucky/components/EditLuckyModal'
import { to } from '@/utils/await'
import { message } from 'ant-design-vue'

export default {
  name: 'FreeDrawer',
  components: { SearchRobot, PageView, STable, AddFreeInput, EditLuckyModal },
  data: function() {
    return {
      currentRobotId: null,
      visible: false,
      queryParam: {},
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: 80,
          scopedSlots: { customRender: 'serial' }
        }, {
          title: '抽奖名称',
          dataIndex: 'relation_to_lucky_draw.luckydraw_name',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'luckydraw_name' }
        }, {
          title: '状态',
          dataIndex: 'status',
          width: 80,
          scopedSlots: { customRender: 'status' }
        }, {
          title: '口令',
          dataIndex: 'item_pwd',
          width: 200,
          scopedSlots: { customRender: 'item_pwd' }
        }, {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 200,
          scopedSlots: { customRender: 'end_time' }
        }, {
          title: '操作',
          width: 150,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      loadData: (params) => {
        return LuckyAPI.getFreeList({
          ...params,
          ...this.queryParam,
          sub_id: this.currentRobotId.sub_id
        })
      }
    }
  },
  methods: {
    show(id) {
      this.currentRobotId = id
      this.queryParam.search_condition = 3
      this.queryParam.keywords = id.prize_id
      this.$refs.table && this.$refs.table.refresh()
      this.visible = true
    },
    async handleDel(record) {
      const hide = message.loading('请稍后...')
      const [err] = await to(LuckyAPI.delFree({
        luckydraw_id: record.luckydraw_id,
        prize_id: record.prize_id,
        sub_id: this.currentRobotId.sub_id
      }))
      hide()
      if (!err) {
        this.$refs.table.refresh()
        return
      }
      message.error(err)
    },

    onChangeRobotId(id) {
      this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
    }
  }
}
</script>

<style scoped>

</style>
